export default __webpack_public_path__ + "static/bottom1-a2ac4211604cee74a0810bd5ce9c7389.png";